escapeChar